import { commonApi } from "../../Menu/Settings/api/commonApi";
import { sortItinerary } from "../utils/sortItinerary";
import { Itinerary } from "../objects/itinerary";

export type GetItineraryArg = {
    tripId: number,
    version: number,
    tripToken: string | null
}

export const itineraryApi = commonApi.injectEndpoints({
    endpoints: (builder) => ({
        // The saved itinerary of a trip version. The cart texts sync reconciles against it instead of the
        // legacy redux itinerary_list, which a flush empties while the trip reloads (zendesk 9084). The
        // legacy writers keep it current through itineraryCacheSyncMiddleware.
        getItinerary: builder.query<Itinerary[], GetItineraryArg>({
            query: (arg) => {
                return {
                    url: `/trip/${arg.tripId}/versions/${arg.version}/itinerary/`,
                    params: { token: arg.tripToken }
                };
            },
            // The token only authorizes the request: keying on it would split the entry the middleware
            // writes (it only knows the trip and the version) from the one the sync reads.
            serializeQueryArgs: ({ queryArgs, endpointName }) => {
                return `${endpointName}(${queryArgs.tripId}-${queryArgs.version})`;
            },
            transformResponse: (response: Itinerary[]) => {
                return [...response].sort(sortItinerary);
            }
        })
    }),
    overrideExisting: false
});

export const { useGetItineraryQuery } = itineraryApi;
